import React, { useState } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Header from './Components/Header/Header'
import Footer from './Components/Footer/Footer'
import Home from './Components/Home/Home'
import ContactUs from './Components/ContactUs/ContactUs'
import AboutUs from './Components/AboutUs/AboutUs'
import ScrollToTop from './Components/ScrollToTop/ScrollToTop';
import ComercialSolutions from './Components/ComercialSolutions/ComercialSolutions';
import HomeSolutions from './Components/HomeSolutions/HomeSolutions';
import Products from './Components/Products/Products';
import FilterLayout from './Components/Products/FilterLayout';
import { Typography } from '@material-tailwind/react';

import ErrorPage from './Components/ErrorPages/ErrorPage'
import { useEffect } from 'react';
import WindFree from './Components/Home/Cards/WindFree/WindFree';
import Cassette from './Components/Home/Cards/360Cassette/360Cassette';
import ProductDetails from './Components/Products/ProductDetails';
import OurProjects from './Components/OurProjects/OurProjects';
import Carrer from './Components/Careers/Careers';

import { Axios } from './Components/Axios/Axios';

const axios = new Axios();

const PING_INTERVAL = 30 * 60 * 1000;

function App() {
  const [isVisible, setIsVisible] = useState(false);
  const [headerBg, setHeaderBg] = useState('transparent');

  useEffect(() => {
    document.querySelector('header').style.background = headerBg
    document.querySelector('header').style.transition = 'background 0.3s ease-in-out'
  }, [headerBg])

  useEffect(() => {

    const lastPing = localStorage.getItem('lastPing');
    const now = Date.now();

    if (!lastPing || now - lastPing > PING_INTERVAL) {
      axios.post('api/home/ping?limit=1&offset=0').then(() => {
        localStorage.setItem('lastPing', now);
      });
    }

    const handleScroll = () => {
      if (window.scrollY > 150) {
        setHeaderBg('white')
      } else {
        setHeaderBg('transparent')
      }
    }

    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  useEffect( () => {
    setTimeout( () => {setIsVisible(true)}, 50)
  }, []);

  return (
    <BrowserRouter>
        <Header />
          {/* <div
            className={`fixed inset-0 flex items-center justify-center backdrop-blur-md z-50 transition-all duration-300 ${
              isVisible ? "opacity-100 visible" : "opacity-0 invisible"
            }`}
          >
            <div className="wrench-container">
              <Typography className='mb-10 font-bold font-sans text-2xl text-white drop-shadow-lg'>
                Во процес на изработка
              </Typography>
              <div className="wrench mt-10"></div>
            </div>
          </div> */}
        <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/contact" element={<ContactUs />} />
            <Route path="/кариера" element={<Carrer />} />
            <Route path="/за-нас" element={<AboutUs />} />
            <Route path="/решенија-за-комерцијални-згради" element={<ComercialSolutions />} />
            <Route path="/решенија-за-вашиот-дом" element={<HomeSolutions />} />
            <Route path="/производи" element={<FilterLayout />} />
            <Route path="/WindFree" element={<WindFree />} />
            <Route path="/360Cassette" element={<Cassette />} />
            <Route path="/производ/:productId" element={<ProductDetails />} />
            <Route path="/наши-проекти" element={<OurProjects />} />
            <Route path='*' element={<ErrorPage/>} />
        </Routes>
        <ScrollToTop />
      <Footer />
  </BrowserRouter>
  );
}

export default App;
